<template>
    <el-dialog width="960px" title="问卷发布设置"
               append-to-body
               :visible.sync="visible">
        <el-form size="small"
                 ref="publishForm"
                 :model="publishForm"
                 label-width="140px"
                 style="width: 80%; margin: 0 auto">
            <el-form-item prop="time" label="问卷时间"
                          :rules="getRules('问卷时间')">
                <el-date-picker v-model="publishForm.time" type="datetimerange"
                                end-placeholder="结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                start-placeholder="开始时间"/>
            </el-form-item>
            <el-form-item prop="JoinMode" label="参与学员" :rules="getRules('参与学员')">
                <el-radio-group v-model="publishForm.JoinMode">
                    <el-radio v-for="radio in joinModeOptions"
                              :key="radio.value"
                              :label="radio.value">{{ radio.label }}
                    </el-radio>
                </el-radio-group>
                <div v-if="publishForm.JoinMode === 2" style="margin-top: 20px">
                    <el-button type="primary"
                               @click.stop="$refs.selectMember.open()">选择用户组/人员
                    </el-button>
                    <h4>已选择用户组</h4>
                    <el-table :data="groups">
                        <el-table-column label="组名称" prop="Name"/>
                        <el-table-column label="操作" width="100">
                            <template v-slot="{ $index }">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="groups.splice($index, 1)">删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <h4>已选择用户</h4>
                    <el-table :data="users">
                        <el-table-column
                            label="真实姓名"
                            prop="RealName"
                        ></el-table-column>
                        <el-table-column
                            label="账号"
                            prop="UserName"
                        ></el-table-column>
                        <el-table-column
                            label="电话"
                            prop="Telephone"
                        ></el-table-column>
                        <el-table-column
                            label="所属用户组"
                            :formatter="defaultVal"
                            prop="GroupName"
                        ></el-table-column>
                        <el-table-column label="操作" width="100">
                            <template v-slot="{$index}">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="users.splice($index, 1)"
                                >删除
                                </el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form-item>
            <el-form-item prop="IsUserDispalyResult" label="问卷结果是否显示" :rules="getRules('问卷结果')">
                <el-radio-group v-model="publishForm.IsUserDispalyResult">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <el-row type="flex" justify="center">
            <el-button plain size="medium"
                       @click.stop="close(false)"
                       round style="min-width: 100px">取消
            </el-button>
            <el-button size="medium"
                       :loading="isLoading"
                       @click.stop="handleConfirm"
                       round type="primary">确认发布问卷
            </el-button>
        </el-row>
        <select-member-dialog
            :selected-group="groups.map(item => item.ID)"
            :selected-member="users"
            @select-user="onSelectUser"
            @select-group="onSelectGroup"
            ref="selectMember"/>
    </el-dialog>
</template>

<script>
import { joinModeOptions } from "./config"
import SelectMemberDialog from "@/components/manager/create-exam/SelectMemberDialog";
import { isEmpty } from "lodash";

export default {
    name: "PublishQuestionnaire",
    components: {
        SelectMemberDialog
    },
    data() {
        return {
            visible: false,
            publishForm: {
                time: [], // 发布时间
                IsUserDispalyResult: 1
            }, // 发布表单
            joinModeOptions,
            groups: [],
            users: [],
            isLoading: false // 确认时的loading
        }
    },
    methods: {
        // 打开
        open() {
            this.visible = true
        },
        // 关闭
        close(onlyLoading) {
            if (onlyLoading) {
                this.isLoading = false
            } else {
                console.log("sss");
                this.isLoading = false
                this.visible = false
            }
        },
        // 选择用户
        onSelectUser(val) {
            this.users = val
        },
        // 选择用户组
        onSelectGroup(val) {
            this.groups = val
        },
        // 处理边界默认值
        defaultVal(row, column, cellValue) {
            if (isEmpty(cellValue)) {
                return "--"
            } else {
                return cellValue
            }
        },
        // 确认
        handleConfirm() {
            this.$refs.publishForm.validate((valid) => {
                if (!valid) return
                const isSpecify = this.publishForm.JoinMode === 2 // 是否指定了人员
                const JoinGroups = this.groups.map(item => item.ID)
                const JoinPeoples = this.users.map(item => item.UserId)
                // 如果选择指定机构人员，那么就必须选择
                if (isSpecify && JoinGroups.length === 0 && JoinPeoples.length === 0) {
                    return this.$message.warning("请选择用户组")
                }
                // 选择的用户组
                const { time, ...otherProps } = this.publishForm
                this.isLoading = true
                this.$emit("confirm",
                    Object.assign(otherProps, {
                        JoinGroups,
                        JoinPeoples,
                        QuestionnaireStartTime: time[0],
                        QuestionnaireEndTime: time[1]
                    }),
                    this.close)
            })
        },
        // 获取规则
        getRules (label) {
            return [
                {
                    message: "请选择" + label,
                    required: true
                }
            ]
        }
    }

}
</script>

<style scoped>

</style>
